<div class="col-md-12 px-5 py-0">
    <div class="d-flex col-md-12 justify-content-end p-0 mb-3" *ngIf="contract?.statusId != 5 && contract?.statusId != 6 && mode != 'view' && !dataLoading && editable">
        <button mat-raised-button color="accent" class="ml-3"
            *ngIf="contract?.statusId != 2 && contract?.createdBy == userService?.loggedinUser?.id"
            (click)="openAddApprover()" [disabled]="isLoading">Adhoc Approver</button>
        <button mat-raised-button color="accent" class="ml-3" (click)="sentForApproval()"
            *ngIf="approvers?.length > 0 && contract?.statusId != 2 && contract?.createdBy == userService?.loggedinUser?.id"
            [disabled]="isLoading">Send for Approval
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
        <button mat-raised-button color="primary" class="ml-3 outlined-btn" (click)="recall()"
            *ngIf="approvers?.length > 0 && contract?.statusId == 2 && contract?.createdBy == userService?.loggedinUser?.id"
            [disabled]="isLoading">Recall
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
    </div>
    <div class="col-md-12 p-0">
        <ng-container *ngIf="!dataLoading; else approverSkeleton">
            <div class="no-data" *ngIf="showBypassApproverNotice">
                <h4>No Approver was added to the flow</h4>
                <p>The approval workflow was bypassed for this contract.</p>
            </div>
            <div class="no-data" *ngIf="showApproverEmptyState">
                <h4>No Approver was added to the flow</h4>
                <p>Please add approvers for this contract!</p>
            </div>
            <ng-container *ngIf="!showBypassApproverNotice && !showApproverEmptyState">
                <div class="flex-wrap d-flex col-md-12 p-0">
                    <div class="teamCard col-md-2 p-0" *ngFor="let approver of approvers">
                        <mat-card>
                            <mat-card-header>
                                <!-- Delete button - only show when status allows deletion -->
                                <!-- <a mat-button color="accent" disableRipple class="position-absolute"
                                    (click)="openDeleteConfirmation(approver.contractsApproverId)"
                                    *ngIf="contract?.createdBy == userService?.loggedinUser?.id && mode != 'view' && editable && contract?.statusId != 2 && contract?.statusId != 8"
                                    [matTooltip]="'Delete Approver'"
                                    [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"><ng-icon
                                        name="heroTrash"></ng-icon></a> -->
                                <!-- View Notes icon - show in place of delete when status is review pending or approval pending -->
                                <button mat-icon-button 
                                (click)="openDeleteConfirmation(approver.contractsApproverId)" 
                                [matTooltip]="'Delete Approver'" 
                                [matTooltipShowDelay]="300" 
                                [matTooltipHideDelay]="100"
                                class="position-absolute delete-icon-btn-header"
                                *ngIf="contract?.createdBy == userService?.loggedinUser?.id && mode != 'view' && editable && contract?.statusId == 1"
                                >
                                <img src="/assets/img/delete-svgrepo-com.svg" alt="Delete Approver" class="note-icon-img">
                              </button>
                              <div class="profile">
                                <span>
                                    <img [src]="approver.userInfo.profilePic ? 'data:image/png;base64,'+approver.userInfo.profilePic : '/assets/img/img_avatar.png'"
                                    class="rounded-circle">
                                </span>
                            </div>
                                <button mat-icon-button 
                                        (click)="openViewNotes(approver)" 
                                        [matTooltip]="'View Notes'" 
                                        [matTooltipShowDelay]="300" 
                                        [matTooltipHideDelay]="100"
                                        class="position-absolute note-icon-btn-header"
                                        >
                                        <img src="/assets/img/note-notepad-svgrepo-com.svg" alt="View Notes" class="note-icon-img">
                                    </button>
                                
                            </mat-card-header>
                            <mat-card-content>
                                <mat-card-title>
                                    {{approver.userInfo.firstName + ' ' +
                                        approver.userInfo.lastName | titlecase}}
                                </mat-card-title>
                                <!-- <mat-card-subtitle>Dept. {{approver.userInfo.department}}</mat-card-subtitle> -->
                                <mat-card-subtitle>Internal Approver</mat-card-subtitle>
                                <mat-card-subtitle>Step No. {{approver.sequenceNo}}</mat-card-subtitle>
                                <mat-card-subtitle class="py-2 d-flex justify-content-center"
                                    *ngIf="contract?.createdBy == userService.loggedinUser.id && mode != 'view' && editable">
                                    <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
                                        *ngIf="isToggleLoading[approver.contractsApproverId]; else loaded"></mat-progress-spinner>
                                    <ng-template #loaded>
                                        <label class="switch">
                                            <input class="switch-input" type="checkbox" [checked]="approver.isActive === true"
                                                (change)="toggleApproverStatus(approver.contractsApproverId)"
                                                [disabled]="contract?.statusId == 2 || contract?.statusId == 3">
                                            <div class="switch-button">
                                                <span class="switch-button-left">Inactive</span>
                                                <span class="switch-button-right">Active</span>
                                            </div>
                                        </label>
                                    </ng-template>
                                </mat-card-subtitle>
                            </mat-card-content>
                            <mat-divider></mat-divider>
                            <mat-card-actions [class.error-background]="approver.status == 2"
                                [class.success-background]="approver.status == 1" *ngIf="approvers?.length > 0 && [2,3,4,5,6,9].includes(contract?.statusId)">
                                <span>{{
                                    approver.status == 1
                                    ? "Approved"
                                    : approver.status == 2
                                    ? "Declined"
                                    : "Approval Pending"
                                    }} </span>
                                <a *ngIf="approver.status == 2" mat-button [matTooltip]="'View Decline Reasons'"
                                    (click)="openRejectReason(approver)" [matTooltipShowDelay]="300"
                                    [matTooltipHideDelay]="100" disableRipple>
                                    <ng-icon name="heroEye"></ng-icon>
                                </a>
                            </mat-card-actions>
                        </mat-card>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #approverSkeleton>
            <div class="flex-wrap d-flex col-md-12 p-0">
                <div class="col-md-2">
                    <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
                </div>
                <div class="col-md-2">
                    <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
                </div>
                <div class="col-md-2">
                    <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
                </div>
                <div class="col-md-2">
                    <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
                </div>
                <div class="col-md-2">
                    <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
                </div>
            </div>
        </ng-template>
    </div>
</div>